import { auth, db } from '../config/firebase'

export const signup = async (email, password) => {
  // create the user account, get credentials back
  const userCredential = await auth.createUserWithEmailAndPassword(email, password)

  // pull the user’s unique ID out of the result
  const uid = userCredential.user.uid

  // Build a reference to their per-user document in the `users` collection
  const userDocRef = db.collection('users').doc(uid)

  // Return a promise that resolves when the document becomes available
  return new Promise((resolve, reject) => {
    const unsubscribe = userDocRef.onSnapshot({
      next: (snapshot) => {
        unsubscribe()
        resolve(snapshot.data())
      },
      error: (error) => {
        unsubscribe()
        reject(error)
      }
    })
  })
}

export const signin = async (email, password) => {
  return await auth.signInWithEmailAndPassword(email, password)
}

export const signout = async () => {
  return await auth.signOut()
}
